var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBattery = function SvgBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 12.5,
    x: 13.5,
    y: 4,
    fill: "none",
    stroke: "currentColor",
    rx: 2,
    transform: "rotate(90 13.5 4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H14a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zM11.5 6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 10 6zM8 6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H6.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5zM4.5 6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 3 6z"
  }))));
};
export default SvgBattery;